import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDateFormat, useTranslation } from 'hooks';
import { SectionBars, SectionCell } from 'components/SectionBars';

function ProjectOverview({
  indexedMeta: { countriesRegion } = { countriesRegion: {} }, // default parameter
  company = null, // default parameter
  personalInformationHeader,
  operationCity = null, // default parameter
  operationArea = [], // default parameter
  positionTitle = null, // default parameter
  startDate = null // default parameter
}) {
  const { t } = useTranslation();

  const location = useMemo(() => {
    let locationVar;
    if (operationCity) {
      locationVar = operationCity;
    }

    if (
      countriesRegion &&
      Object.entries(countriesRegion).length !== 0 &&
      operationArea &&
      operationArea.length >= 0
    ) {
      if (!locationVar) locationVar = countriesRegion[operationArea[0]];
      else locationVar += ' / ' + countriesRegion[operationArea[0]];
    }
    return locationVar;
  }, [countriesRegion, operationArea, operationCity]);

  const startDateValue = useDateFormat(startDate);

  return (
    <React.Fragment>
      <SectionBars
        header={
          <React.Fragment>
            {personalInformationHeader}
            <h3>{t('label.positionInformation')}</h3>
          </React.Fragment>
        }
        title={t('label.positionInformation')}
      >
        <SectionCell label={t('label.company')} size="30%" value={company || '-'} />
        <SectionCell label={t('label.position')} size="30%" value={positionTitle || '-'} />
        <SectionCell label={t('label.location')} size="20%" value={location || '-'} />
        <SectionCell
          label={t('label.dateFrom')}
          size="20%"
          value={startDate ? startDateValue : '-'}
        />
      </SectionBars>
    </React.Fragment>
  );
}

ProjectOverview.propTypes = {
  company: PropTypes.string,
  indexedMeta: PropTypes.shape({
    countriesRegion: PropTypes.object.isRequired
  }).isRequired,
  operationArea: PropTypes.array,
  operationCity: PropTypes.string,
  personalInformationHeader: PropTypes.object,
  positionTitle: PropTypes.string,
  startDate: PropTypes.string
};

export default ProjectOverview;
